































































import { DataProxy } from 'apollo-cache';
import * as R from 'ramda';
import Vue from 'vue';

import { Retailer, Outlet } from '@/core/entity';

import OutletForm from './Form.vue';
import { getRetailerQL } from './graphql';

export default Vue.extend({
  components: {
    'form-outlet': OutletForm,
  },

  apollo: {
    retailer: {
      query: getRetailerQL,
      variables() {
        return { id: this.retailerId };
      },
      skip() {
        return !this.retailerId;
      },
      fetchPolicy: 'cache-first',
    },
  },

  data() {
    const outletId = this.$route.params.outlet_id;
    return {
      isDrawerVisible: outletId ? true : false,
      loading: false,
      retailer: null as Retailer | null,
    };
  },

  computed: {
    drawerTitle(): string {
      return this.outletId ? 'Edit outlet' : 'Create a new outlet';
    },
    outletId(): string {
      return this.$route.params.outlet_id;
    },
    retailerId(): string {
      return this.$route.params.retailer_id;
    },
  },

  watch: {
    outletId(newVal: string | null) {
      this.isDrawerVisible = !!newVal;
    },
  },

  methods: {
    handleSave(val: any) {
      const { outletId, retailerId } = this;
      const input = {
        retailerId,
        name: val.name,
        address: val.address,
        lat: val.lat,
        lon: val.lon,
      };
      if (outletId) {
        // edit outlet
        this.$coreApp.outlet.update(
          outletId!,
          input,
          this.presenter('Outlet updated.', 'Unable to update outlet:', false),
          this.updater,
        );
      } else {
        this.$coreApp.outlet.create(
          input,
          this.presenter('Outlet created.', 'Unable to create outlet:', true),
          this.updater,
        );
      }
    },
    hideDrawer() {
      this.isDrawerVisible = false;
      if (this.outletId) {
        this.$router.back();
      }
    },
    presenter(success: string, failure: string, isNew: boolean) {
      return (err: Error | null, result: Outlet | null, loading: boolean) => {
        this.loading = loading;
        if (err) {
          this.$message.error(`${failure} ${err.message}`);
        } else if (result !== null) {
          this.$message.success(success);

          if (isNew) {
            this.isDrawerVisible = false;
          } else {
            this.$router.back();
          }
        }
      };
    },
    showDrawer() {
      this.isDrawerVisible = true;
    },
    getCountry(id: any) {
      switch (id) {
        case 'my':
          return 'Malaysia';
        case 'sg':
          return 'Singapore';
        case 'id':
          return 'Indonesia';

        default:
          return 'Malaysia';
      }
    },
    updater(
      store: DataProxy,
      res: { data: { newOutlet?: Outlet; updateOutlet?: Outlet } },
    ) {
      const outlet = (res.data.updateOutlet || res.data.newOutlet) as Outlet;

      const data: { retailer: Retailer } | null = store.readQuery({
        query: getRetailerQL,
        variables: { id: this.retailerId },
      });

      const isNew = res.data.newOutlet;
      if (isNew) {
        data!.retailer.outlets = R.prepend(outlet, data!.retailer.outlets!);
      } else {
        const idx = R.findIndex(R.propEq('id', outlet.id))(
          data!.retailer.outlets!,
        );
        if (idx === -1) {
          // tslint:disable-next-line no-console
          console.error('Unable to find outlet in outlets.');
          return;
        }
        const previous = data!.retailer.outlets![idx];
        data!.retailer.outlets = R.update(
          idx,
          {
            ...previous,
            ...outlet,
          },
          data!.retailer.outlets!,
        );
      }

      store.writeQuery({
        query: getRetailerQL,
        variables: { id: this.retailerId },
        data,
      });
    },
  },
});
